import DialogModal from 'src/components/ui/dialogModal';
import { useBlocker } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';

interface IModalProps {
    titleContent: string;
    bodyContent: string;
    footerContent?: any;
    cancelBtnLabel: string;
    confirmBtnLabel: string;
    onCancelHandler: Function;
    onConfirmHandler: Function;
    isLoading?: boolean;
    isConfirmBtnRed?: boolean;
    isContentCentered?: boolean;
    showButtons?: boolean;
    icon?: string;
    isBigModal?: boolean;
    isError?: boolean;
    progress?: number;
    modalExtraClass?: string;
}

interface PromptProps extends IModalProps {
    show: boolean;
    beforeUnload?: boolean;
}

const Prompt: React.FC<PromptProps> = ({
    show,
    beforeUnload = false,
    titleContent,
    bodyContent,
    footerContent,
    cancelBtnLabel,
    confirmBtnLabel,
    onCancelHandler,
    onConfirmHandler,
    isLoading,
    isConfirmBtnRed,
    isContentCentered = false,
    showButtons = true,
    icon,
    isBigModal = false,
    isError = false,
    progress = undefined,
    modalExtraClass = '',
}) => {
    const [showAlert, setShowAlert] = useState(false);
    useEffect(() => {
        if (beforeUnload) {
            const handleBeforeUnload = (e: any) => {
                if (show) {
                    e.preventDefault();
                    return true;
                }
                return null;
            };
            window.addEventListener('beforeunload', handleBeforeUnload);
            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, [show, beforeUnload]);
    const blockerCallback = useCallback(
        ({ historyAction }) => {
            if (show && historyAction !== 'POP') {
                setShowAlert(true);
                return true;
            }
            return false;
        },
        [show],
    );

    // Using useBlocker hook to block navigation
    const navBlocker = useBlocker(blockerCallback);
    const onConfirmNavigation = () => {
        if (navBlocker.state === 'blocked') {
            navBlocker.proceed();
        }
        setShowAlert(false);
        onConfirmHandler();
    };

    const onCancelNavigation = () => {
        if (navBlocker.state === 'blocked') {
            navBlocker.reset();
        }
        setShowAlert(false);
        onCancelHandler();
    };
    return (
        <DialogModal
            titleContent={titleContent}
            bodyContent={bodyContent}
            open={show && showAlert}
            cancelBtnLabel={cancelBtnLabel}
            confirmBtnLabel={confirmBtnLabel}
            onCancelHandler={onCancelNavigation}
            onConfirmHandler={onConfirmNavigation}
            isContentCentered={isContentCentered}
            showButtons={showButtons}
            icon={icon}
            isBigModal={isBigModal}
            isError={isError}
            progress={progress}
            modalExtraClass={modalExtraClass}
            footerContent={footerContent}
            isLoading={isLoading}
            isConfirmBtnRed={isConfirmBtnRed}
        />
    );
};

export default Prompt;
